// extracted by mini-css-extract-plugin
export default {"item":"CartItem_item__LbRf8","details":"CartItem_details__ncuXR","price":"CartItem_price__LZ1+4","total":"CartItem_total__JH-HN"};